<div>
  <div *ngIf="au.isInput" (click)="backOption()" class="auto-ml-page__back-btn">
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none">
        <path d="M6.10243 11.4625L1.20001 6.56004L6.17495 1.59961" stroke="#3267FF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.0217 6.53125H1.20001" stroke="#3267FF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>   Back
  </div>
  <div class="auto-ml-stepper">
    <div *ngFor="let steps of au.stepperOptions;let i=index" [ngClass]="{'auto-ml-stepper--completed':steps.step,'auto-ml-stepper__last':steps.last,'auto-ml-stepper__last-node':i==3,'auto-ml-stepper__dashed':au.iterationSet.length===1 && au.isSatisfy &&( i==2 || i==3)}" class="auto-ml-stepper__box">
        <div class="auto-ml-stepper__icon">
            <img src="assets/images/svg/waiting-icon.svg" alt="" class="auto-ml-stepper__waiting-icon">
            <img src="assets/images/svg/greenbg-tick-icon.svg" alt="" class="auto-ml-stepper__completed-icon">
        </div>
        <div class="auto-ml-stepper__contents">
            <div class="auto-ml-stepper__small-txt">
                {{'Stage '+(i+1)}}
            </div>
            <div class="auto-ml-stepper__bold-txt" [innerHTML]="steps.name">
              
            </div>
        </div>
    </div>
    <!-- <div class="auto-ml-stepper__box auto-ml-stepper--completed auto-ml-stepper__last" >
        <div class="auto-ml-stepper__icon">
            <img src="assets/images/svg/waiting-icon.svg" alt="waiting-icon" class="auto-ml-stepper__waiting-icon">

            <img src="assets/images/svg/greenbg-tick-icon.svg" alt="" class="auto-ml-stepper__completed-icon">
        </div>
        <div class="auto-ml-stepper__contents">
            <div class="auto-ml-stepper__small-txt">
                Stage 2
            </div>
            <div class="auto-ml-stepper__bold-txt">
              Run your Model
            </div>
        </div>
    </div>
    <div class="auto-ml-stepper__box" [ngClass]="{'cssClass': au.iterationSet[0].target_columns.length >0 && !au.isSatisfy}">
        <div class="auto-ml-stepper__icon">
            <img src="assets/images/svg/waiting-icon.svg" alt="waiting-icon" class="auto-ml-stepper__waiting-icon">

            <img src="assets/images/svg/greenbg-tick-icon.svg" alt="" class="auto-ml-stepper__completed-icon">
        </div>
        <div class="auto-ml-stepper__contents">
            <div class="auto-ml-stepper__small-txt">
                Stage 3
            </div>
            <div class="auto-ml-stepper__bold-txt">
              Analyze your results 
            </div>
        </div>
    </div>
    <div class="auto-ml-stepper__box auto-ml-stepper__last-node">
        <div class="auto-ml-stepper__icon">
            <img src="assets/images/svg/waiting-icon.svg" alt="waiting-icon" class="auto-ml-stepper__waiting-icon">

            <img src="assets/images/svg/greenbg-tick-icon.svg" alt="" class="auto-ml-stepper__completed-icon">
        </div>
        <div class="auto-ml-stepper__contents">
            <div class="auto-ml-stepper__small-txt">
                Stage 4
            </div>
            <div class="auto-ml-stepper__bold-txt">
              Re-Analyze your results
            </div>
        </div>
    </div>
    <div class="auto-ml-stepper__box">
        <div class="auto-ml-stepper__icon">
            <img src="assets/images/svg/waiting-icon.svg" alt="waiting-icon" class="auto-ml-stepper__waiting-icon">

            <img src="assets/images/svg/greenbg-tick-icon.svg" alt="" class="auto-ml-stepper__completed-icon">
        </div>
        <div class="auto-ml-stepper__contents">
            <div class="auto-ml-stepper__small-txt">
                Stage 5
            </div>
            <div class="auto-ml-stepper__bold-txt">
              Create Scenarios
            </div>
        </div>
    </div> -->
  </div>

</div>
